import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, keywords, image, url, type = 'website', noindex = false }) {
    const siteTitle = 'VipEncuentros';
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const defaultDescription = 'El portal exclusivo para encontrar scorts masculinos, hombres para sexo y masajistas calientes. Perfiles reales y verificados.';
    const defaultKeywords = 'scort masculino, sexo, hombres, masajistas, gay, escort, santiago, chile, encuentros, xxx, masajes eroticos, chicos, acompañantes';
    const defaultImage = 'https://vipencuentros.com/og-image.jpg';
    const defaultUrl = 'https://vipencuentros.com/';

    const metaDescription = description || defaultDescription;
    const metaKeywords = keywords || defaultKeywords;
    const metaImage = image || defaultImage;
    const metaUrl = url || defaultUrl;

    const schemaOrgJSONLD = [
        {
            '@context': 'http://schema.org',
            '@type': 'WebSite',
            url: defaultUrl,
            name: siteTitle,
            alternateName: 'Vip Encuentros Chile',
        },
    ];

    return (
        <Helmet>
            {/* Standard metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            <link rel="canonical" href={metaUrl} />
            {noindex && <meta name="robots" content="noindex" />}

            {/* Facebook Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={metaUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:site_name" content={siteTitle} />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={metaUrl} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaImage} />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(schemaOrgJSONLD)}
            </script>
        </Helmet>
    );
}
